import React from 'react';

import ChangeCta from 'components/SingleMenu/ChangeCta';

import styles from './ExpandControls.module.scss';

type expandType = {
  label: string;
  disabled: boolean;
  onClick: () => void;
};

interface Props {
  isAllExpanded: boolean;
  isAllCollapsed: boolean;
  handleExpandAll: () => void;
  handleCollapseAll: () => void;
}

const ExpandControls: React.FC<Props> = ({ isAllExpanded, isAllCollapsed, handleExpandAll, handleCollapseAll }) => {
  const options: expandType[] = [
    {
      label: 'Collapse all',
      disabled: isAllCollapsed,
      onClick: handleCollapseAll
    },
    {
      label: 'Expand all',
      disabled: isAllExpanded,
      onClick: handleExpandAll
    }
  ];

  return (
    <div className={`container ${styles.Outer}`}>
      <ChangeCta />
      <ul className={styles.ExpandControls}>
        {options.map(({ label, disabled, onClick }) => {
          return (
            <li key={label}>
              <button type="button" disabled={disabled} onClick={onClick}>
                {label}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ExpandControls;
